export default __webpack_public_path__ + "static/media/carta7.22ce615d.png";